const currentRequests = {}

/**
 * concurrent: { type: Boolean, default: false, Comment: '是否相同url可以并发请求' },
 */

const host =
  process.env.NODE_ENV == 'production'
    ? ''
    : $.getEnv().url

$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
  // 设置默认域名
  if (!/^http/.test(options.url)) {
    options.url = `${host}${options.url}`
  }

  // 设置请求方式
  if (!options.method) {
    options.type = options.data ? 'POST' : 'GET'
  }

  const request = currentRequests[options.url]

  // 请求如果成功 就不能再去发起同样的请求
  // 如果请求失败 可重复请求
  const succeedOnce = request && request === 'success' && options.succeedOnce

  if (succeedOnce) {
    jqXHR.abort()
    return
  }

  // 长江后浪推前浪 假如前一个自己正在进行请求
  // 后一个同url的请求进来了 停止掉前一个请求
  if (request && !options.concurrent) {
    request.abort()
  }

  // 当前运行的request
  currentRequests[options.url] = jqXHR
})

/**
 *处理request请求成功、完成后的回调函数
 */
function isSuccess(jqXHR) {
  return (
    jqXHR.readyState === 4 &&
    jqXHR.responseJSON &&
    Number(jqXHR.responseJSON.code) === 200
  )
}

$(document)
  .ajaxSuccess(function (event, jqXHR, options) {
    if (jqXHR.responseJSON && jqXHR.responseJSON.code == 302) {
      $.clearLoginInfo()
    }
    if (options.succeedOnce && isSuccess(jqXHR)) {
      currentRequests[options.url] = 'success'
    }
  })
  .ajaxComplete(function (event, jqXHR, options) {
    if (!(options.succeedOnce && isSuccess(jqXHR))) {
      delete currentRequests[options.url]
    }
  })
